import { render, staticRenderFns } from "./analizraporu.vue?vue&type=template&id=2cc4d1e6&scoped=true"
import script from "./analizraporu.vue?vue&type=script&lang=js"
export * from "./analizraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4d1e6",
  null
  
)

export default component.exports